    <!-- Global thin top bar that shows on every route change for the
         1-second floor (and on any other registered task). -->
    <app-vl-nav-progress [active]="progressActive()"></app-vl-nav-progress>

    <div class="app" [class.sidebar-collapsed]="app.sidebarCollapsed()">
      <app-sidebar></app-sidebar>
      <div class="main">
        <app-topbar [crumbs]="crumbs()"></app-topbar>
        <ng-content></ng-content>
      </div>
    </div>

    <!-- Floating in-console chat (hides itself on the full Messages page + auth). -->
    <app-chat-launcher></app-chat-launcher>

    <!-- Global Issue Reporter — Ctrl/Cmd+Shift+B captures the page and
         files an issue. Mounted here so every route inherits it; the
         component is inert until the hotkey fires. -->
    <app-issue-reporter></app-issue-reporter>

    <!-- "Voyago" idle mascot — inert until enabled in SYSTEM → Settings (admin-gated). -->
    <app-voyago-mascot></app-voyago-mascot>
